import React, { useEffect, useState } from "react";
import { getAllGeneralLedger } from "../../api/endpoints/search";
import { authSelector } from "../../store/selectors/index";
import { useSelector } from "react-redux";
import { Modal, message, Select } from "antd";
import { AiFillSave } from "react-icons/ai";
import { AiFillDelete } from "react-icons/ai";
import { LuView } from "react-icons/lu";
import { AiFillEdit } from "react-icons/ai";
import { AiFillFileAdd } from "react-icons/ai";
import { BiExit } from "react-icons/bi";
import "./party.css";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import {
  getAllParty,
  createAccount,
  updateSingleAccount,
  deleteSingleAccount,
} from "../../api/endpoints/party";
import SideBar from "../sidebar/sideBar.js";
const { Option } = Select;

const Party = () => {
  const { user, access_token } = useSelector(authSelector);
  const [fieldsShow, setFieldsShow] = useState(false);
  const [itemsQueue, setItemsQueue] = useState([]);
  const [siteName, setSiteName] = useState();
  const [siteAddress, setSiteAddress] = useState();
  const [loading, setLoading] = useState(false);
  const [type, setType] = useState("ADD");
  const [state, setState] = useState({
    ledgerCodes: [],
    glCode: "",
    glDescription: "",
    parties: [],
    partyId: "",
    partyName: "",
    address: "",
    phone: "",
    email: "",
    partyType: "",
    billType: "",
    billTime: "",
    billSummary: "",
    unBilledBalence: "",
    billedBalence: "",
    description: "",
    bChrages: "",
    closed: "",
    suspended: "",
  });

  const clearState = () => {
    setState({
      id: "",
      ledgerCodes: state.ledgerCodes,
      parties: state.parties,
      partyId: "",
      partyName: "",
      glCode: "",
      glDescription: "",
      address: "",
      phone: "",
      email: "",
      partyType: "",
      billType: "",
      billTime: "",
      billSummary: "",
      unBilledBalence: "",
      billedBalence: "",
      description: "",
      closed: "",
      suspended: "",
    });
    setItemsQueue([]);
  };

  console.log(state, "Vall");

  const onChangeText = (e, object) => {
    if (object) {
      const { name, value } = object;
      setState({
        ...state,
        [name]: value,
      });
    } else {
      const { name, value } = e.target;
      setState({
        ...state,
        [name]: value,
      });
    }
  };
  const addTank = async () => {
    setType("SAVE");
    setFieldsShow(true);
    setState({
      ...state,
      billTime: "Monthly",
      partyType: "Customer",
      billType: "Vehicle Wise",
      closed: 0,
    });
  };
  const saveTank = async (e) => {
    if (
      !state.partyId ||
      !state.partyName ||
      !state.glCode ||
      !state.glDescription ||
      !state.partyType
    ) {
      return message.error(
        `Please type ${
          !state.glCode
            ? "General Ledger Code"
            : !state.glDescription
              ? "Gl Description"
              : !state.partyId
                ? "Account Number"
                : !state.partyName
                  ? "Party Name"
                  : !state.partyType
                    ? "Party Type"
                    : ""
        }`
      );
    }

    const payload = {
      PID: state.partyId,
      PtyName: state.partyName,
      Address: state.address,
      Phone: state.phone,
      Email: state.email,
      PType: state.partyType,
      BlType: state.billType,
      BlTime: state.billTime,
      FRate: Number(state.bChrages),
      ORate: Number(state.bChrages),
      GLCode: Number(state.glCode),
      closed: Number(state.closed),
      siteId: Number(user.siteId),
      // companyCode: Number(user.companyCode),
    };

    // console.log(payload)
    const results = await createAccount(payload, access_token);
    if (results.success) {
      message.success(results.message || "Successfully entered!");
      clearState();
      setFieldsShow(false);
      setType("ADD");
    } else {
      message.error(results.message);
    }
  };

  const editTank = async () => {
    setType("EDIT");
    setFieldsShow(true);
  };

  const saveEditTank = async (e) => {
    if (type === "EDIT") {
      if (
        !state.partyId ||
        !state.partyName ||
        !state.glCode ||
        !state.glDescription ||
        !state.partyType
      ) {
        return message.error(
          `Please type ${
            !state.glCode
              ? "General Ledger Code"
              : !state.glDescription
                ? "Gl Description"
                : !state.partyId
                  ? "Account Number"
                  : !state.partyName
                    ? "Party Name"
                    : !state.partyType
                      ? "Party Type"
                      : ""
          }`
        );
      }
      const data = {
        partyId: state.partyId,
        PtyName: state.partyName,
        Address: state.address,
        Phone: state.phone,
        Email: state.email,
        PType: state.partyType,
        BlType: state.billType,
        BlTime: state.billTime,
        FRate: Number(state.bChrages),
        ORate: Number(state.bChrages),
        GLCode: Number(state.glCode),
        closed: Number(state.closed),
        grpId: Number(user.grpId),
        siteId: Number(user.siteId),
      };
      console.log(data, "edite data");
      const results = await updateSingleAccount(data, access_token);
      if (results.success) {
        message.success(results.message || "Successfully Updated!");
        clearState();
        setFieldsShow(false);
        setType("ADD");
      } else {
        message.error(results.message);
      }
    } else {
      if (!state.partyId) return message.error("Please Select Account");
      modal.confirm({
        title: `Confirm`,
        content: "Are you sure you want to delete this Account?",
        okText: "Delete",
        cancelText: "Cancel",
        onOk: confirmDeleteNozel,
      });
    }
  };
  const confirmDeleteNozel = async () => {
    const data = {
      partyId: state.partyId,
    };
    const results = await deleteSingleAccount(data, access_token);
    if (results.success) {
      message.success(results.message || "Deleted Successfully!");
      clearState();
      setFieldsShow(false);
      setType("ADD");
    } else {
      message.error(results.message);
    }
  };

  const [modal, contextHolder] = Modal.useModal();
  const deleteNozel = async () => {
    setType("DELETE");
    setFieldsShow(true);
  };
  const confirmDelete = () => {
    modal.confirm({
      title: `Confirm`,
      content: "You want to delete Account?",
      okText: "Yes",
      cancelText: "Cancel",
      onOk: deleteNozel,
    });
  };

  const clearStates = () => {
    clearState();
    setFieldsShow(false);
    setType("ADD");
  };

  const getAllData = async () => {
    const _parties = await getAllParty(access_token);
    const _ledgerCodes = await getAllGeneralLedger(access_token);
    setState({
      ...state,
      parties: _parties,
      ledgerCodes: _ledgerCodes,
    });
  };
  useEffect(() => {
    getAllData();

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const editHandler = async (e) => {
    try {
      setLoading(true);
      const results = await getAllParty(access_token);
      const payload = results.reduce((acc, curr) => {
        return [
          ...acc,
          {
            partyId: curr.PID,
            partyName: curr.PtyName,
            generalLedgerCode: curr.GLCode,
            description: curr.description,
          },
        ];
      }, []);
      setItemsQueue(payload);
      generatePDF(payload);
    } catch (err) {
      console.error(err);
      message.error("Something went wrong!");
    } finally {
      setLoading(false);
    }
  };

  const generatePDF = (data) => {
    if (!data || data.length === 0) {
      message.error("No data to generate report!");
      return;
    }

    // Landscape A4
    const doc = new jsPDF("p", "mm", "a4");

    // Title
    // doc.setFontSize(16);
    // doc.text(`${siteName}`, 148, 11, { align: "center" });
    // doc.setFontSize(12);
    // doc.text(`${siteAddress}`, 148, 16, { align: "center" });
    doc.setFontSize(11);
    doc.text(`Parties List`, 100, 21, { align: "center" });

    // ✅ Prepare table rows
    const tableRows = data.map((item, index) => [
      index + 1,
      item.partyId || "",
      item.partyName || "",
      item.generalLedgerCode || "",
      item.description || "",
    ]);

    // ✅ Generate table
    autoTable(doc, {
      head: [["SNO", "Party ID", "Party Name", "GL Code", "Description"]],
      body: tableRows,
      startY: 26,
      theme: "grid",
      margin: { left: 5, right: 5 },
      styles: {
        fontSize: 9,
        cellPadding: 1,
        textColor: [0, 0, 0],
        lineColor: [0, 0, 0],
        lineWidth: 0.5,
        valign: "middle",
      },
      headStyles: {
        fillColor: [255, 255, 255],
        textColor: [0, 0, 0],
        fontStyle: "bold",
        halign: "center",
        lineColor: [0, 0, 0],
        lineWidth: 0.5,
      },
      columnStyles: {
        0: { halign: "center", cellWidth: 10 },
        1: { halign: "left", cellWidth: 20 },
        2: { halign: "left", cellWidth: 90 },
        3: { halign: "center", cellWidth: 20 },
        4: { halign: "left", cellWidth: 50 },
      },
    });

    // ✅ Open PDF in new tab
    const pdfBlob = doc.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);
    window.open(pdfUrl);
  };

  return (
    <>
      <div className="flex bg-black main">
        <SideBar />
        <div className="h-full  flex flex-col content-center  w-full">
          <div className="flex justify-center">
            <div className="meterTableMain flex flex-col justify-items-center justify-center w-1/2 ml-10 mt-5 mr-10">
              <div className="bg-blue-500 headingBox flex justify-center">
                <h1 className="text-white">Add Party Account</h1>
                {contextHolder}
              </div>
              <div className="p-2 flex justify-center">
                {fieldsShow && (
                  <div className="w-70">
                    <div className="flex justify-evenly w-full">
                      <div className="w-1/2 mb-3">
                        <label className="text-white" htmlFor="fname">
                          Account Number:
                        </label>
                        {type === "EDIT" || type === "DELETE" ? (
                          <>
                            <Select
                              className="bg-black text-slate-400 inpTxt  h-8 w-full"
                              showSearch
                              placeholder=""
                              optionFilterProp="children"
                              value={state.partyId || ""}
                              onChange={(e) => {
                                const _accountInfo = state.parties.find(
                                  (el) => el.PID === e
                                );
                                console.log("e", _accountInfo);
                                setState({
                                  ...state,
                                  partyId: _accountInfo.PID,
                                  partyName: _accountInfo.PtyName,
                                  glCode: _accountInfo.GLCode,
                                  glDescription: _accountInfo.description, // from joined chartOfAccount
                                  address: _accountInfo.Address,
                                  phone: _accountInfo.Phone,
                                  email: _accountInfo.Email,
                                  partyType: _accountInfo.PType,
                                  billType: _accountInfo.BlType,
                                  billTime: _accountInfo.BlTime,
                                  billSummary: _accountInfo.BlSmry,
                                  closed: _accountInfo.Suspended,
                                  bChrages: _accountInfo.ORate,
                                });
                              }}
                            >
                              {state.parties.map((el) => (
                                // console.log(el, "el")
                                <Option value={el.PID}>
                                  {`${el.PID} - ${el.PtyName}`}
                                </Option>
                              ))}
                            </Select>
                          </>
                        ) : (
                          <input
                            type="number"
                            name="partyId"
                            value={state.partyId}
                            onChange={onChangeText}
                            className="bg-black text-slate-400  inpTxt h-8 w-full"
                          />
                        )}
                      </div>
                      <div className="w-1/2 mb-3">
                        <label className="text-white ml-3" htmlFor="fname">
                          Name :
                        </label>
                        <input
                          type="text"
                          name="partyName"
                          value={state.partyName}
                          onChange={onChangeText}
                          className="bg-black text-slate-400 inpTxt p-2 h-8 w-full ml-3"
                        />
                      </div>
                    </div>
                    <div className="flex justify-evenly w-full">
                      <div className="w-1/2 mb-3">
                        <label className="text-white" htmlFor="fname">
                          Phone :
                        </label>
                        <input
                          type="text"
                          name="phone"
                          value={state.phone}
                          onChange={onChangeText}
                          className="bg-black text-slate-400 inpTxt p-2 h-8 w-full"
                        />
                      </div>
                      <div className="w-1/2 mb-3">
                        <label className="text-white ml-3" htmlFor="fname">
                          Email :
                        </label>
                        <input
                          type="email"
                          name="email"
                          value={state.email}
                          onChange={onChangeText}
                          className="bg-black text-slate-400 inpTxt p-2 h-8 w-full ml-3"
                        />
                      </div>
                    </div>
                    <div className="flex justify-evenly w-full">
                      <div className="w-1/2 mb-3">
                        <label className="text-white" htmlFor="fname">
                          Address :
                        </label>
                        <input
                          type="text"
                          name="address"
                          value={state.address}
                          onChange={onChangeText}
                          className="bg-black text-slate-400 inpTxt p-2 h-8 w-full"
                        />
                      </div>
                     
                    </div>
                    <div className="flex justify-evenly w-full">
                      <div className="w-1/2 mb-3">
                        <label className="text-white " htmlFor="fname">
                          Party Type :
                        </label>
                        <Select
                          showSearch
                          className="text-black inpTxt  h-9 w-full"
                          placeholder="No"
                          optionFilterProp="children"
                          value={state.partyType || "Customer"}
                          onChange={(value) =>
                            onChangeText({
                              target: { name: "partyType", value },
                            })
                          }
                        >
                          <Option value={"C"} name="partyType">
                            Customer
                          </Option>
                          <Option value={"D"} name="partyType">
                            Card
                          </Option>
                          <Option value={"S"} name="partyType">
                            Supplier
                          </Option>
                          <Option value={"M"} name="partyType">
                            Miscellaneous
                          </Option>
                          <Option value={"E"} name="partyType">
                            Employee
                          </Option>
                        </Select>
                      </div>
                      
                    </div>
                    <div className="flex justify-evenly w-full">
                      <div className="w-1/2 mb-3">
                        <label className="text-white" htmlFor="fname">
                          GL Description :
                        </label>
                        <Select
                          showSearch
                          className="text-black inpTxt  h-9 w-full"
                          placeholder="GL Description"
                          optionFilterProp="children"
                          value={state.glDescription || "GL Description "}
                          onChange={(e) => {
                            const lCode = state.ledgerCodes.find(
                              (el) => el.CODE === e
                            );
                            setState({
                              ...state,
                              glCode: e,
                              glDescription: lCode.Description,
                            });
                          }}
                        >
                          {state.ledgerCodes.map((el) => (
                            <Option value={el.CODE}>{el.Description}</Option>
                          ))}
                        </Select>
                      </div>
                      <div className="w-1/2 mb-3">
                        <label className="text-white ml-3" htmlFor="fname">
                          GL Code :
                        </label>
                        <Select
                          showSearch
                          className="text-black inpTxt  h-9 w-full ml-3"
                          placeholder="Credit GL Code"
                          optionFilterProp="children"
                          value={state.glCode || "Credit GL Code"}
                          onChange={(e) => {
                            const lCode = state.ledgerCodes.find(
                              (el) => el.CODE === e
                            );
                            setState({
                              ...state,
                              glCode: e,
                              glDescription: lCode.Description,
                            });
                          }}
                        >
                          {state.ledgerCodes.map((el) => (
                            <Option value={el.CODE}>{el.CODE}</Option>
                          ))}
                        </Select>
                      </div>
                    </div>
                    <div className="flex justify-evenly w-full">
                      <div className="w-1/2 mb-3">
                        <label className="text-white" htmlFor="fname">
                          Closed:
                        </label>
                        <Select
                          showSearch
                          className="text-black inpTxt  h-9 w-full"
                          placeholder="No"
                          optionFilterProp="children"
                          value={state.closed === "" ? "No" : state.closed}
                          onChange={(value) =>
                            onChangeText({
                              target: { name: "closed", value },
                            })
                          }
                        >
                          <Option value={0} name="closed">
                            No
                          </Option>
                          <Option value={1} name="closed">
                            Yes
                          </Option>
                        </Select>
                      </div>
                      
                    </div>
                  </div>
                )}
              </div>
              <div class="flex justify-center pb-3">
                {type === "ADD" && (
                  <button
                    onClick={addTank}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 py-1 px-4 rounded"
                  >
                    <AiFillFileAdd className="mr-2 mt-1" />

                    <span>Add</span>
                  </button>
                )}

                {type === "SAVE" && (
                  <button
                    onClick={saveTank}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 py-1 px-4 rounded"
                  >
                    <AiFillSave className="mt-1 mr-2 " />
                    <span>Save</span>
                  </button>
                )}
                {type === "ADD" && (
                  <button
                    onClick={editHandler}
                    disabled={loading}
                    className={`bg-blue-500 hover:bg-blue-700 flex text-white ml-2 mt-3 py-1 px-4 rounded ${
                      loading
                        ? "opacity-50 cursor-not-allowed"
                        : "hover:bg-blue-700"
                    }`}
                  >
                    <LuView className="mt-1 mr-2 " />
                    {loading ? "Loading..." : "View"}
                  </button>
                )}
                {type === "ADD" && (
                  <button
                    onClick={editTank}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                  >
                    <AiFillEdit className="mr-2 mt-1" />

                    <span>Edit</span>
                  </button>
                )}

                {(type === "EDIT" || type === "DELETE") && (
                  <button
                    onClick={saveEditTank}
                    className="bg-blue-500 hover:bg-blue-700 text-white ml-2 mt-3 py-1 px-4 rounded"
                  >
                    DONE
                  </button>
                )}
                {type === "ADD" && (
                  <button
                    onClick={confirmDelete}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                  >
                    <AiFillDelete className="mr-2 mt-1" />

                    <span>Delete</span>
                  </button>
                )}
                {type !== "ADD" && (
                  <button
                    onClick={clearStates}
                    className="bg-blue-500 hover:bg-blue-700 flex text-white mt-3 ml-3 py-1 px-4 rounded"
                  >
                    <BiExit className="mr-2 mt-1" />
                    <span>Exit</span>
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Party;
